import { useLanguage } from "../../context/LanguageContext";
import { Seo } from "../../components/Seo";
import { LegalShell, Block } from "./LegalShell";

export default function CookiePolicy() {
  const { t } = useLanguage();
  const sections = t("legal.cookies.sections") || [];
  return (
    <>
      <Seo title={t("legal.cookies.seoTitle")} description={t("legal.cookies.seoDesc")} />
      <LegalShell
        title={t("legal.cookies.title")}
        subtitle={t("legal.cookies.intro")}
        updated={t("legal.updatedDate")}
      >
        {sections.map((s, i) => (
          <Block key={i} heading={s.heading}>
            {s.paragraphs.map((p, j) => (
              <p key={j}>{p}</p>
            ))}
          </Block>
        ))}

        <div className="mt-10 overflow-hidden rounded-2xl border border-foreground/10">
          <table className="w-full border-collapse text-sm">
            <thead className="bg-gold/8">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-gold">{t("legal.cookies.tableName")}</th>
                <th className="px-4 py-3 text-left font-medium text-gold">{t("legal.cookies.tablePurpose")}</th>
                <th className="px-4 py-3 text-left font-medium text-gold">{t("legal.cookies.tableDuration")}</th>
                <th className="px-4 py-3 text-left font-medium text-gold">{t("legal.cookies.tableType")}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-foreground/10">
              {(t("legal.cookies.table") || []).map((row, i) => (
                <tr key={i}>
                  <td className="px-4 py-3 font-mono text-xs text-foreground/85">{row.name}</td>
                  <td className="px-4 py-3 text-foreground/70">{row.purpose}</td>
                  <td className="px-4 py-3 text-foreground/70">{row.duration}</td>
                  <td className="px-4 py-3 text-foreground/70">{row.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </LegalShell>
    </>
  );
}
